import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";

import { SharedModule } from '../shared/shared.module';
import { PAGES_ROUTES } from './pages.routes';

import { PagesComponent } from './pages.component'
import { HomeComponent } from './home/home.component';
import { DetailsComponent } from './details/details.component';
import { AboutComponent } from './about/about.component';
import { LineComponent } from './line/line.component';
import { ContactComponent } from './contact/contact.component';
import { YouTubePlayerModule } from '@angular/youtube-player';

@NgModule({
  declarations: [
    PagesComponent,
    HomeComponent,
    DetailsComponent,
    AboutComponent,
    LineComponent,
    ContactComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PAGES_ROUTES,
    YouTubePlayerModule
  ],
  providers: []
})

export class PagesModule { }
